export const CLAN_TASK_TYPES = {
    CRAWL: 'crawl',
    STRONGHOLD: 'stronghold',
    GLOBAL_MAP: 'global_map',
    SQUAD: 'squad',
}

export const PERSONAL_TASK_TYPES = {
    EXPERIENCE: 'experience',
    KILL: 'kill',
    WIN: 'win',
    DAMAGE: 'damage',
    TOP: 'top',
    ACHIEVEMENT: 'achievement',
}

export const QUEST_TYPES = {
    1: 'first',
    2: 'second',
    3: 'third',
}

export const QUEST_STATUSES = {
    INCOMPLETE: 'INCOMPLETE',
    REWARD_AVAILABLE: 'REWARD_AVAILABLE',
    REWARD_PENDING: 'REWARD_PENDING',
    COMPLETE: 'COMPLETE',
}

export const TANK_STATUSES = {
    UNAVAILABLE: 'UNAVAILABLE',
    AVAILABLE: 'AVAILABLE',
    ACQUIRED: 'ACQUIRED',
}

export const CLAN_SUPPLY_FOOTER_STATUSES = {
    DEFAULT: 'default',
    TAKE_PRIZE: 'takePrize',
    SUCCESS: 'success',
    CAN_EXAMINE: 'canExamine',
}

export const QUEST_RULES = {
    FULL_DAMAGE: 'FULL_DAMAGE',
    EXP: 'EXP',
    FRAGS: 'FRAGS',
    WIN: 'WIN',
}

export const QUEST_SQUAD = {
    PLATOON: 'platoon',
    SOLO: 'solo',
    DETACHMENT: 'detachment',
}

export const TaskType = {
    GET_FREE_XP: 'GET_FREE_XP',
    DESTROY_VEHICLES: 'DESTROY_VEHICLES',
    WIN_REGULAR_BATTLE: 'WIN_REGULAR_BATTLE',
    GET_COMPLEX_DAMAGE: 'GET_COMPLEX_DAMAGE',
    GET_TOP_10_BY_XP: 'GET_TOP_10_BY_XP',
    GET_EPIC_ACHIEVEMENTS: 'GET_EPIC_ACHIEVEMENTS',
    PLAY_SORTIE_BATTLE: 'PLAY_SORTIE_BATTLE',
    GET_OFFENSIVE_BATTLE: 'GET_OFFENSIVE_BATTLE',
    GET_GLOBAL_MAP_BATTLE: 'GET_GLOBAL_MAP_BATTLE',
    GET_CLAN_SQUAD_BATTLE: 'GET_CLAN_SQUAD_BATTLE',
}

export const TaskRewardType = {
    PERSONAL: 'PERSONAL',
    CLAN: 'CLAN',
}

export const RewardType = {
    PERSONAL_RESERVES: 'personal_reserves',
    PREBATTLE_INSTRUCTIONS: 'prebattle_instructions',
    PREMIUM: 'premium',
    EQUIPMENT: 'equipment',
    BONDS: 'crystals',
    CREDITS: 'credits',
    FREE_XP: 'freeXP',
    CREW_BOOKS: 'crew_books',
    INDUSTRIAL_RESOURCE: 'industrial_resource',
}

export const PersonalReservesType = {
    CREW_XP: 'booster_crew_xp',
    FREE_XP: 'booster_free_xp',
    XP: 'booster_xp',
    CREDITS: 'booster_credits',
}

export const PrebattleInstructionsType = {
    AIMING_STABILIZER: 'aimingStabilizer',
    CAMOUFLAGE: 'camouflage',
    COATED_OPTICS: 'coatedOptics',
    ENHANCED_AIM_DRIVES: 'enhancedAimDrives',
    FIRE_FIGHTING: 'fireFighting',
    IMPROVED_VENTILATION: 'improvedVentilation',
    LAST_EFFORT: 'lastEffort',
    PEDANT: 'pedant',
    RAMMER: 'rammer',
    RANCOROUS: 'rancorous',
    SIXTH_SENSE: 'sixthSense',
    SMOOTH_DRIVING: 'smoothDriving',
    SMOOTH_TURRET: 'smoothTurret',
    TOOLBOX: 'toolbox',
    VIRTUOSO: 'virtuoso',
}

export const EquipmentType = {
    AIMING_STABILIZER: 'aimingStabilizer',
    ANTIFRAGMENTATION_LINING: 'antifragmentationLining',
    AUTO_EXTINGUISHERS: 'autoExtinguishers',
    CAMOUFLAGE: 'camouflage',
    CAMOUFLAGE_NET: 'camouflageNet',
    CARBON_DIOXIDE: 'carbonDioxide',
    CHOCOLATE: 'chocolate',
    COATED_OPTICS: 'coatedOptics',
    COCACOLA: 'cocacola',
    ENHANCED_AIM_DRIVES: 'enhancedAimDrives',
    FILTER_CYCLONE: 'filterCyclone',
    FIRE_FIGHTING: 'fireFighting',
    GASOLINE_100: 'gasoline100',
    GASOLINE_105: 'gasoline105',
    GROUSERS: 'grousers',
    HAND_EXTINGUISHERS: 'handExtinguishers',
    HOT_COFFEE: 'hotCoffee',
    IMPROVED_VENTILATION: 'improvedVentilation',
    LARGE_MEDKIT: 'largeMedkit',
    LARGE_REPAIRKIT: 'largeRepairkit',
    LEND_LEASE_OIL: 'lendLeaseOil',
    QUALITY_OIL: 'qualityOil',
    RAMMER: 'rammer',
    RATION_CHINA: 'ration_china',
    RATION_CZECH: 'ration_czech',
    RATION_ITALY: 'ration_italy',
    RATION_JAPAN: 'ration_japan',
    RATION_POLAND: 'ration_poland',
    RATION_SWEDEN: 'ration_sweden',
    RATION_UK: 'ration_uk',
    RATION: 'ration',
    REMOVED_RPM_LIMITER: 'removedRpmLimiter',
    SMALL_MEDKIT: 'smallMedkit',
    SMALL_REPAIR_KIT: 'smallRepairkit',
    STEEL_ROLLERS: 'steelRollers',
    STEREOSCOPE: 'stereoscope',
    TOOLBOX: 'toolbox',
    WET_COMBAT_PACK: 'wetCombatPack',
}

export const CrewBookType = {
    BROCHURE_CHINA: 'brochure_china',
    BROCHURE_FRANCE: 'brochure_france',
    BROCHURE_ITALY: 'brochure_italy',
    BROCHURE_POLAND: 'brochure_poland',
    BROCHURE_SWEDEN: 'brochure_sweden',
    BROCHURE_USA: 'brochure_usa',
    BROCHURE_CZECH: 'brochure_czech',
    BROCHURE_GERMANY: 'brochure_germany',
    BROCHURE_JAPAN: 'brochure_japan',
    BROCHURE_RANDOM: 'brochure_random',
    BROCHURE_UK: 'brochure_uk',
    BROCHURE_USSR: 'brochure_ussr',
    CREWBOOK_CHINA: 'crewBook_china',
    CREWBOOK_FRANCE: 'crewBook_france',
    CREWBOOK_ITALY: 'crewBook_italy',
    CREWBOOK_POLAND: 'crewBook_poland',
    CREWBOOK_UK: 'crewBook_uk',
    CREWBOOK_USSR: 'crewBook_ussr',
    CREWBOOK_CZECH: 'crewBook_czech',
    CREWBOOK_GERMANY: 'crewBook_germany',
    CREWBOOK_JAPAN: 'crewBook_japan',
    CREWBOOK_SWEDEN: 'crewBook_sweden',
    CREWBOOK_USA: 'crewBook_usa',
    GUIDE_CZECH: 'guide_czech',
    GUIDE_GERMANY: 'guide_germany',
    GUIDE_JAPAN: 'guide_japan',
    GUIDE_SWEDEN: 'guide_sweden',
    GUIDE_USA: 'guide_usa',
    GUIDE_CHINA: 'guide_china',
    GUIDE_FRANCE: 'guide_france',
    GUIDE_ITALY: 'guide_italy',
    GUIDE_POLAND: 'guide_poland',
    GUIDE_UK: 'guide_uk',
    GUIDE_USSR: 'guide_ussr',
    PERSONAL_BOOK: 'personalBook',
    UNIVERSAL_BOOK: 'universalBook',
}

export const RewardSubtype = {
    INDUSTRIAL_RESOURCE: 'custom/industrial_resource',
    BONDS: 'custom/crystal',
    CREDITS: 'custom/credits',
    PREMIUM_PLUS: 'custom/premium_plus',
    GOODIE_FREE_EXPERIENCE: 'goodie/free_experience',
    GOODIE_EXPERIENCE: 'goodie/experience',
    GOODIE_CREW_EXPERIENCE: 'goodie/crew_experience',
    GOODIE_FL_EXPERIENCE: 'goodie/fl_experience',
    GOODIE_CREDITS: 'goodie/credits',
    EQUIPMENT: 'item/equipment',
    CREW_BOOK_BROCHURE: 'crew_book/brochure',
    CREW_BOOK_GUIDE: 'crew_book/guide',
    CREW_BOOK_CREW_BOOK: 'crew_book/crewBook',
    CREW_BOOK_PERSONAL_BOOK: 'crew_book/personalBook',
    CREW_BOOK_UNIVERSAL_BOOK: 'crew_book/universalBook',
    BLUEPRINT_NATIONAL: 'blueprint/national',
    BLUEPRINT_INTELEGENCE_DATA: 'blueprint/intelligence_data',
    BLUEPRINT_ANY: 'blueprint/any',
}
export const TaskCondition = {
    /**
     * Should player win battle to complete task step.
     */
    DEMAND_WIN: 'demandWin',
    /**
     * Should player be at least in top10 by pure xp to complete task step.
     */
    DEMAND_TOP_10: 'demandTop10',
    /**
     * Restrict player to play in squad.
     */
    DEMAND_SQUAD: 'demandSquad',
}



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/clan_quests_constants.js